import type { RewarbleIconsId } from '@repo/icons';
import type { HTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export type IconProps = {
  name: RewarbleIconsId;
  className?: string;
} & HTMLAttributes<HTMLElement>;

export const Icon = ( { className, name, ...attrs }: IconProps ) => {

  return (
    <i
      className={ cn( `flex rewarble-new-icons rewarble-new-icons-${ name } text-2xl`, className ) }
      { ...attrs }
    />
  )
}
Icon.displayName = 'Icon';
